module.exports = __webpack_public_path__ + "img/brand_4.553504d4.png";